import freeMap from "./free.json";
import essentialsMap from "./essentials.json";
import proMap from "./pro.json";
import enterPriseMap from "./enterprise.json";

export const planMap = {
    Free: freeMap,
    Essentials: essentialsMap,
    Pro: proMap,
    Enterprise: enterPriseMap,
};
